/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PatchApprovalRequestPathParams = NonNullable<operations['patchApprovalRequest']['parameters']['path']>;

export type PatchApprovalRequestRequestBody = OperationRequestBodyContent<operations['patchApprovalRequest']>;

export interface Input extends PatchApprovalRequestPathParams {
  apiVersion?: string;
  body: PatchApprovalRequestRequestBody;
}

export async function patchApprovalRequest(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/api/v2/approval-requests/{id}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
